import api from '@edu-fe/api'

export default {
  name: 'wealth',
  namespaced: true,
  state: {
    wealthData: {}, // 红包信息
    invitationCourse: [], // 知识合伙人邀请课程
    courseList: [], // 邀请课程列表
    wealthDetailData: [] // 红包明细
  },
  mutations: {
    setWealthData: (state, data) => (state.wealthData = data),
    setCourseList: (state, data) => (state.courseList = data),
    setInvitationCourse: (state, data) => (state.invitationCourse = data),
    resetWealthDetail: state => (state.wealthDetailData = []),
    setWealthDetailData: (state, data) => (state.wealthDetailData = state.wealthDetailData.concat(data))
  },
  actions: {
    getWealthData ({ commit }) {
      api.wealth.getWealthData()().then(res => {
        commit('setWealthData', res.data)
      }).catch(err => console.error(err))
    },
    getInvitationCourse ({ commit, rootState }, name = '') {
      const { provide } = rootState.route.query
      if (provide === 'ciba') {
        return api.wealth.getCibaCourse({ name }).then(res => {
          console.log(res)
          if (res.code === 1042) {
            window.location.href = 'https://edu-ciba.iciba.com'
            return
          }
          commit('setInvitationCourse', res.data)
        })
      }

      api.wealth.getInvitationCourse().then(res => {
        commit('setInvitationCourse', res.data.list)
      })
    },
    getCourseList ({ commit }, { pageNo = 1, pageSize = 3 }) {
      api.wealth.getCourseData({
        pageNo, pageSize
      }).then(res => {
        commit('setCourseList', res.data)
      }).catch(err => console.error(err))
    },
    getWealthDetailData ({ commit }, { pageNo = 1, pageSize = 10 }) {
      return api.wealth.getWealthDetailData({
        pageNo, pageSize
      }).then(res => {
        commit('setWealthDetailData', res.data)
        return res.data
      }).catch(err => console.error(err))
    },
    share ({ commit }, { id, type }) {
      api.wealth.share({
        id, type
      }).then(res => {
        console.log(res)
      }).catch(err => console.error(err))
    },
    draw () {
      return api.wealth.drawMoney()
    },
    checkWealthStatus () {
      return api.wealth.getWealthStatus()
    },
    dealInvitationCourse ({ commit }, data) {
      commit('setInvitationCourse', data)
    }
  }
}
